export const reduxKey = '@@modals';
export const actionPrefix = '@@MODALS';

//# sourceMappingURL=constants.js.map